/**
 * @generated SignedSource<<87250c1ed9f97e9cf746b7b121a3681e>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import type { ReaderFragment } from 'relay-runtime';
export type SearchShortcutColor = "BLUE" | "GRAY" | "GREEN" | "ORANGE" | "PINK" | "PURPLE" | "RED" | "%future added value";
export type SearchShortcutIcon = "ALERT" | "ARCHIVE" | "BEAKER" | "BOOKMARK" | "BRIEFCASE" | "BUG" | "CALENDAR" | "CLOCK" | "CODESCAN" | "CODE_REVIEW" | "COMMENT" | "COMMENT_DISCUSSION" | "COPILOT" | "DEPENDABOT" | "EYE" | "FILE_DIFF" | "FLAME" | "GEAR" | "GIT_PULL_REQUEST" | "GLOBE" | "HOME" | "HUBOT" | "ISSUE_OPENED" | "LINK" | "MENTION" | "METER" | "MOON" | "NORTH_STAR" | "ORGANIZATION" | "PEOPLE" | "PERSON" | "REPO" | "REPO_FORKED" | "REPO_LOCKED" | "REPO_TEMPLATE" | "ROCKET" | "SMILEY" | "SQUIRREL" | "STAR" | "SUN" | "TELESCOPE" | "TERMINAL" | "TOOLS" | "ZAP" | "%future added value";
import type { FragmentRefs } from "relay-runtime";
export type SavedViewRow$data = {
  readonly color: SearchShortcutColor;
  readonly description: string;
  readonly icon: SearchShortcutIcon;
  readonly id: string;
  readonly name: string;
  readonly query: string;
  readonly scopingRepository: {
    readonly name: string;
    readonly owner: {
      readonly login: string;
    };
  } | null | undefined;
  readonly " $fragmentType": "SavedViewRow";
};
export type SavedViewRow$key = {
  readonly " $data"?: SavedViewRow$data;
  readonly " $fragmentSpreads": FragmentRefs<"SavedViewRow">;
};

const node: ReaderFragment = (function(){
var v0 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "name",
  "storageKey": null
};
return {
  "argumentDefinitions": [],
  "kind": "Fragment",
  "metadata": null,
  "name": "SavedViewRow",
  "selections": [
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "id",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "icon",
      "storageKey": null
    },
    (v0/*: any*/),
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "color",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "description",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "query",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "concreteType": "Repository",
      "kind": "LinkedField",
      "name": "scopingRepository",
      "plural": false,
      "selections": [
        (v0/*: any*/),
        {
          "alias": null,
          "args": null,
          "concreteType": null,
          "kind": "LinkedField",
          "name": "owner",
          "plural": false,
          "selections": [
            {
              "alias": null,
              "args": null,
              "kind": "ScalarField",
              "name": "login",
              "storageKey": null
            }
          ],
          "storageKey": null
        }
      ],
      "storageKey": null
    }
  ],
  "type": "SearchShortcut",
  "abstractKey": null
};
})();

(node as any).hash = "ccf64a6e8946f133ba890e4c61f6e60e";

export default node;
